import {
  AfterViewInit,
  Component,
  ComponentRef,
  ElementRef,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { NguModal } from '../ngu-modal';
// import { NguModalService } from '@ngu/modal';
import {
  ConfirmationDialog,
  ConfirmationMsgDefault
} from './confirmation-dialog';
// import { NguModal } from './../ngu-modal';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, AfterViewInit {
  afterView: boolean;
  // listeners: () => void;
  confirmModalIndex: any;
  compRef: ComponentRef<any>;
  // @ViewChild('yes') yes: ElementRef;
  // @ViewChild('no') no: ElementRef;
  @ViewChildren('buttons') buttons: QueryList<ElementRef>;
  confirmData = new ConfirmationDialog();
  @ViewChild('modal', { read: NguModal })
  modal: NguModal;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.confirmModalIndex = {
      id: 'sampleText',
      backdrop: false
    };
  }

  ngAfterViewInit() {
    this.afterView = true;
    // this.yes.nativeElement.focus();
    this.modal.open();
  }

  destroy() {
    this.compRef.destroy();
    // this.listeners();
  }

  confirm(ref: ComponentRef<any>, data: ConfirmationDialog) {
    this.compRef = ref;
    this.setData(data);
    return new Promise((resolve, reject) => {
      // this.listeners = this.renderer.listen(
      //   this.yes.nativeElement,
      //   'click',
      //   () => {
      //     this.modal.close();
      //     resolve(true);
      //   }
      // );
      setTimeout(() => {
        this.buttons.forEach(btn => {
          this.renderer.listen(btn.nativeElement, 'click', $event => {
            const value = btn.nativeElement.getAttribute('value');
            if (value === 'true') {
              resolve(true);
            } else if (value === 'false') {
              resolve(false);
            } else {
              resolve(value);
            }
            this.modal.close();
            // resolve(false);
          });
        });
      }, 10);
      // this.yes.nativeElement.onclick = () => {
      // };
      // this.no.nativeElement.onclick = () => {
      //   this.modal.close();
      //   resolve(false);
      // };
    });
  }

  setData(data: ConfirmationDialog) {
    this.confirmData.heading = (data && data.heading) || 'Delete';
    this.confirmData.body =
      (data && data.body) || 'Are you sure you want to delete this?';
    let btns:any = [];
    let otherBtns:any = [];
    this.confirmData.buttons = [];
    otherBtns.push(
      {
        name: (data && data.noButton) || 'Cancel',
        value: false,
        color: 'cancel'
      },
      {
        name: (data && data.yesButton) || 'Confirm',
        value: true,
        color: 'confirm'
      }
    );
    if (data && data.buttons) {
      btns = data.buttons;
      if (data.othersBtn) {
        btns = [...otherBtns, ...btns];
      }
    } else {
      btns = otherBtns;
    }
    // console.log(btns);
    this.confirmData.buttons = btns;
    // this.confirmData.yesButton = (data && data.yesButton) || 'Confirm';
    // this.confirmData.noButton = (data && data.noButton) || 'Cancel';
  }
}

const confirmMessages: ConfirmationMsgDefault = {
  update: {
    heading: 'Update',
    body: 'Are you sure you want to update ?',
    yesButton: 'update',
    noButton: 'cancel'
  },
  delete: {
    heading: 'Delete',
    body: 'Are you sure you want to delete this?',
    yesButton: 'Delete',
    noButton: 'cancel'
  }
};
